import Service from '@/services/Service'
import http from '@/services'

class IfoodService extends Service {
  constructor() {
    super('IFOOD')
    this.resource = 'ifood'
  }

  async getContract() {
    let requestUrl = `${this.resource}/auth/contract`
    let data = await this.getAPI(requestUrl)
    return data
  }

  async getOrders(query) {
    const url = `${this.resource}/order-gestao`
    let requestUrl = ''
    if (query) requestUrl += this.createRequestUrl(query, url)

    const data = await this.getAPI(requestUrl)
    return data
  }

  async getOrderIntegration(id) {
    let requestUrl = `${this.resource}/order/${id}`
    return await this.getAPI(requestUrl)
  }

  // rotas de ação pedidos
  async confirmOrder(payload) {
    let requestUrl = `${this.resource}/order/confirm`

    return await http.post(requestUrl, payload)
  }
  async startPreparationOrder(payload) {
    let requestUrl = `${this.resource}/order/start-preparation`
    return await http.post(requestUrl, payload)
  }
  async readyToPickupOrder(payload) {
    let requestUrl = `${this.resource}/order/ready`
    return await http.post(requestUrl, payload)
  }
  async dispatchOrder(payload) {
    let requestUrl = `${this.resource}/order/dispatch`
    return await http.post(requestUrl, payload)
  }

  async getOrderCancellationReasons(payload) {
    let requestUrl = `${this.resource}/order/cancellation-reasons`
    return await http.post(requestUrl, payload)
  }

  async cancelOrder(payload) {
    let requestUrl = `${this.resource}/order/request-cancellation`
    return await http.post(requestUrl, payload)
  }
  async acceptCancellation(payload) {
    let requestUrl = `${this.resource}/order/accept-cancellation`
    return await http.post(requestUrl, payload)
  }
  async denyCancellation(payload) {
    let requestUrl = `${this.resource}/order/deny-cancellation`
    return await http.post(requestUrl, payload)
  }

  // integrations route
  async createIntegration() {
    let requestUrl = `/integrations/create`
    return await http.post(requestUrl)
  }

  async getSynchronizationLog(payload) {
    let requestUrl = this.createRequestUrl(payload, `${this.resource}/logs`)
    return await http.get(requestUrl)
  }

  // integration ifood routes
  async getStatusMerchant() {
    let requestUrl = `${this.resource}/integration/status`
    const data = await this.getAPI(requestUrl)
    return data
  }

  async getMerchants() {
    let requestUrl = `${this.resource}/integration`
    const data = await this.getAPI(requestUrl)
    return data
  }

  async getInterruptions() {
    let requestUrl = `${this.resource}/integration/interruptions`
    return await this.getAPI(requestUrl)
  }

  async createInterruption(payload) {
    let requestUrl = `${this.resource}/integration/interruptions`
    return await http.post(requestUrl, payload)
  }

  async deleteInterruption(payload) {
    let requestUrl = `${this.resource}/integration/interruptions/` + payload.id
    return await http.delete(requestUrl)
  }
}

export default new IfoodService()
